import React from 'react';

const FormPesaje = ({ formDatos, setFormDatos }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Peso (kg) *</label>
      <input type="number" step="0.1" value={formDatos.peso || ''} onChange={(e) => setFormDatos(p => ({ ...p, peso: e.target.value }))}
        placeholder="280" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500" data-testid="campo-peso" autoFocus />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Altura Cadera (cm)</label>
      <input type="number" step="0.1" value={formDatos.altura_cadera || ''} onChange={(e) => setFormDatos(p => ({ ...p, altura_cadera: e.target.value }))}
        placeholder="115" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Frame (1-9)</label>
      <input type="number" min="1" max="9" value={formDatos.frame || ''} onChange={(e) => setFormDatos(p => ({ ...p, frame: e.target.value }))}
        placeholder="6" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">CC (1-9)</label>
      <select value={formDatos.condicion_corporal || ''} onChange={(e) => setFormDatos(p => ({ ...p, condicion_corporal: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-cc">
        <option value="">--</option>
        {[1,2,3,4,5,6,7,8,9].map(n => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Lote/Corral</label>
      <input type="text" value={formDatos.lote || ''} onChange={(e) => setFormDatos(p => ({ ...p, lote: e.target.value }))}
        placeholder="Lote 1" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div className="sm:col-span-2">
      <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
      <input type="text" value={formDatos.observaciones || ''} onChange={(e) => setFormDatos(p => ({ ...p, observaciones: e.target.value }))}
        placeholder="Notas..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
  </div>
);

export default FormPesaje;
